export default "__VITE_ASSET__WZjVKR1j__"